import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Facebook(): React.ReactElement {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 14C25 20.6274 19.6274 26 13 26C6.37258 26 1 20.6274 1 14C1 7.37258 6.37258 2 13 2C19.6274 2 25 7.37258 25 14Z" fill="white"/>
      <path d="M13.0001 0.0540466C5.82041 0.0540466 0 5.87445 0 13.0541C0 19.4935 4.68678 24.8263 10.8319 25.859V15.7663H7.69593V12.1344H10.8319V9.4563C10.8319 6.34899 12.7298 4.65569 15.5021 4.65569C16.8299 4.65569 17.971 4.75463 18.3022 4.79821V8.04617L16.3794 8.0471C14.872 8.0471 14.5814 8.76326 14.5814 9.81453V12.1325H18.1782L17.709 15.7644H14.5814V25.9458C21.0135 25.163 26 19.6943 26 13.0504C26 5.87445 20.1796 0.0540466 13.0001 0.0540466Z" fill="#3264EF"/>
    </svg>
  );
}
